import React, { Suspense, lazy }  from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import { buildBlocks } from "../../../services/builder";
// import { VimeoFrame } from "../../Pub/Banner/Banner";
const VimeoFrame = lazy(() => import("./VimeoFrame"))

const useStyles = makeStyles((theme) => ({
  bannerMessage: {
    position: "relative",
    marginBottom: 36,
    "& > .gatsby-image-wrapper": {
      marginLeft: "50%",
      transform: "translateX(-50%)",
      maxWidth: "100vw",
      width: "calc(100% + 50px) !important",
      zIndex: "1",
      overflow: "hidden",
      backgroundColor: "#333",
      backgroundPosition: "center !important",
      backgroundSize: "cover !important",
      "& > div": {
        paddingBottom: "550px !important",
      },
      "& .video-wrapper": {
        position: "absolute",
        top: "50%",
        bottom: 0,
        width: "100%",
        paddingBottom: "0 !important",
        height: "56vw",
        minHeight: 595,
        minWidth: 1070,
        left: "50%",
        transform: "translate(-50%, -50%)",
        "& iframe": {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100% !important",
          height: "100% !important",
          minHeight: 595,
          minWidth: 1070,
        },
      },
      [theme.breakpoints.up("md")]: {
        height: "auto !important",
        width: "100vw !important",
        "& > div": {
          paddingBottom: "640px !important",
        },
      },
    },
    "& .content-wrap": {
      position: "absolute",
      bottom: 90,
      zIndex: "3",
      [theme.breakpoints.up("sm")]: {
        maxWidth: "85%",
      },
      [theme.breakpoints.up("md")]: {
        bottom: 50,
      },
      "& > a": {
        marginTop: 30,
        display: "table",
      },
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      color: "white",
      marginBottom: "0",
    },
  },
  bannerMessageTheme: {
    ...theme.videoBannerMessageTheme,
  },
}));

export const CgbVideoBannerMessageBlock = (props) => {
  const blocks = buildBlocks(
    props.innerBlocks,
    props.parentAttributes,
    props.pageContext
  );
  const classes = useStyles();

  let poster = { backgroundImage: "url(" + props.attributes.mediaUrl + ")" };
  if (props.attributes.mediaUrlSharp != null) {
    poster = {
      backgroundImage:
        "url(" +
        props.attributes.mediaUrlSharp.childImageSharp?.gatsbyImageData
          ?.srcWebp +
        ")",
    };
  }

  return (
    <div
      className={`banner-message ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.bannerMessage} ${classes.bannerMessageTheme}`}
    >
      <div className="gatsby-image-wrapper">
        <div style={{ paddingBottom: "50%" }} />
        <Suspense fallback={<div>Loading...</div>}>
          <VimeoFrame videoId={props.attributes.videoID} fallbackImg={poster} />
        </Suspense>
      </div>

      <div className="content-wrap">
        {blocks.map((block) => {
          return block;
        })}
      </div>
    </div>
  );
};

CgbVideoBannerMessageBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

export const CgbVideoBannerMessageBlockFragment = graphql`
  fragment CgbVideoBannerMessageBlock on WpBlock {
    ... on WpCgbVideoBannerMessageBlock {
      name
      attributes {
        __typename
        ... on WpCgbVideoBannerMessageBlockAttributes {
          className
          videoID
          mediaUrl
          mediaUrlSharp {
            id
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1440
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                transformOptions: { fit: COVER, cropFocus: CENTER }
              )
            }
          }
        }
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbVideoBannerMessageBlockPreview = `
    ... on CgbVideoBannerMessageBlock {
        name
        attributes {
            __typename
            ... on CgbVideoBannerMessageBlockAttributes {
                className
                videoID
                mediaUrl
            }
        }
    }
`;
